var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row system-alerts" }, [
    _c(
      "div",
      { staticClass: "col" },
      [
        _vm.data.length > 0
          ? _vm._l(_vm.data, function(entry) {
              return _c(
                "button",
                {
                  staticClass: "c-btn c-btn--warning",
                  on: {
                    click: function($event) {
                      return _vm.showAlert(entry)
                    }
                  }
                },
                [
                  _c("fa", { attrs: { icon: ["far", "info-square"] } }),
                  _vm._v(
                    "\n                " +
                      _vm._s(entry.short_notice) +
                      "\n            "
                  )
                ],
                1
              )
            })
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }